import { useAccountRepository } from '@frontend/repository';

import { useAppDispatch } from '../../redux/store';

export const useSettingsList = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();

    return {
        currentAccount,
        dispatch
    };
};
